export default "__VITE_ASSET__3879adc9__"